const {gql} = require('graphql-tag')
export default gql`
  mutation createArtworkToFiles ($input: ArtworkToFileInputs!) {
    createArtworkToFiles (input: $input) {
      id
    }
  }
`
